import React, { useState } from 'react'

import Box from '@mui/material/Box'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'

import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import DayforceAgencyPreferencesExpandedList from 'components/common/ExpandedList/AgencyPreferences/Dayforce'

function AgencyPreferencesCell({ row, colId, getDataDisplay }) {
  return (
    <TableCell sx={{ borderBottom: 0 }}>{getDataDisplay(row, colId)}</TableCell>
  )
}

function AgencyPreferencesRow({
  row,
  rowKey,
  visibleColumns = [],
  getDataDisplay,
  openAgencyModal,
  columns,
}) {
  const [expanded, setExpanded] = useState(false)

  return (
    <>
      <TableRow key={row[rowKey]} sx={{ border: 0 }}>
        {visibleColumns.map((col) => (
          <>
            <AgencyPreferencesCell
              key={`${row[rowKey]}-${col}`}
              row={row}
              getDataDisplay={getDataDisplay}
              colId={col}
            />
          </>
        ))}
        <TableCell sx={{ borderBottom: 0 }}>
          <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
            <Button
              size="small"
              variant="contained"
              color="primary"
              onClick={() => openAgencyModal(row, 'edit')}
              sx={{ flex: 1, my: 'auto' }}
            >
              Edit
            </Button>
            <Button
              size="small"
              variant="outlined"
              color="primary"
              onClick={() =>
                openAgencyModal(row, row.is_active ? 'deactivate' : 'activate')
              }
              sx={{ flex: 1, my: 'auto' }}
            >
              {row.is_active ? 'Deactivate' : 'Activate'}
            </Button>
          </Box>
        </TableCell>
        <TableCell sx={{ borderBottom: 0 }}>
          <IconButton
            sx={{
              float: 'right',
            }}
            edge="end"
            aria-label="expand"
            onClick={(e) => {
              e.stopPropagation()
              setExpanded(!expanded)
            }}
          >
            {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow sx={{ backgroundColor: expanded && 'hover.main' }}>
        <TableCell sx={{ pb: 0, pt: 0 }} colSpan={12}>
          <DayforceAgencyPreferencesExpandedList
            expanded={expanded}
            visibleColumns={visibleColumns}
            getDataDisplay={getDataDisplay}
            rowData={row}
            columns={columns}
          />
        </TableCell>
      </TableRow>
    </>
  )
}

export default AgencyPreferencesRow
